module.exports = __webpack_public_path__ + "static/truyen-ngan--con-sau-tinh-yeu-cua-con-meo-truu-tuong-d586f762af46e1ab4de047f3d561b4c0.jpg";